import { render } from "./OdsHeader.vue?vue&type=template&id=0259a4f0"
import script from "./OdsHeader.vue?vue&type=script&lang=js"
export * from "./OdsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__